import { createSlice } from "@reduxjs/toolkit";
import { getHashTags } from "./thunk";

export interface IState {
  hashTags: any;
  isHashTagLoading: boolean;
  isHashTagSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  hashTags: null,
  isHashTagLoading: false,
  isHashTagSuccess: false,

  error: {},
};

const HashTagSlice = createSlice({
  name: "HashTag",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get hashtag
    builder.addCase(getHashTags.pending, (state: IState, action: any) => {
      state.isHashTagLoading = true;
    });
    builder.addCase(getHashTags.fulfilled, (state: IState, action: any) => {
      state.hashTags = action.payload.data;
      state.isHashTagSuccess = true;
      state.isHashTagLoading = false;
    });
    builder.addCase(getHashTags.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isHashTagSuccess = false;
      state.isHashTagLoading = false;
    });
  },
});

export default HashTagSlice.reducer;
